import { Check } from "lucide-react";
import { Reveal } from "./Reveal";
import { WaButton } from "./WaButton";

const ETAPAS = [
  "Entendimento inicial do problema.",
  "Verificação do serviço necessário.",
  "Alinhamento de escopo e orçamento.",
  "Execução conforme o serviço contratado.",
  "Orientação sobre as condições de garantia aplicáveis.",
];

export default function Equipe() {
  return (
    <section id="equipe" data-testid="hidropro-team-section" className="relative py-16 md:py-24 lg:py-32">
      <div className="mx-auto grid max-w-7xl grid-cols-1 items-center gap-12 px-4 sm:px-6 lg:grid-cols-2 lg:gap-16 lg:px-8">
        <Reveal>
          <figure className="tick-corner relative mx-auto w-fit overflow-hidden rounded-2xl border border-[rgba(10,92,140,0.25)] bg-gradient-to-b from-white via-white to-[#E0EEF7] shadow-[0_30px_80px_rgba(10,92,140,0.12)]" data-testid="hidropro-team-photo">
            <img
              src="/equipe-hidropro.jpg"
              alt="Técnico da HidroPro segurando chave de tubo"
              loading="lazy"
              className="block h-[520px] w-auto object-contain sm:h-[620px] lg:h-[660px]"
            />
            <figcaption className="absolute bottom-4 left-4 rounded-full bg-brand-ink/85 px-4 py-1.5 font-mono text-[10px] uppercase tracking-[0.2em] text-white backdrop-blur">
              HidroPro · Serviços Técnicos
            </figcaption>
          </figure>
        </Reveal>

        <div>
          <Reveal>
            <h2 className="font-display text-2xl font-bold tracking-tight text-[#1A1A1A] sm:text-3xl lg:text-4xl">
              Atendimento técnico com escopo claro
            </h2>
          </Reveal>
          <Reveal delay={0.08}>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-slate-600 sm:text-lg">
              Cada instalação possui características específicas. Por isso, a HidroPro Serviços Técnicos avalia a
              necessidade apresentada antes de indicar o serviço e definir as condições de execução.
            </p>
          </Reveal>
          <Reveal delay={0.16}>
            <ul className="mt-7 flex flex-col gap-3.5">
              {ETAPAS.map((etapa) => (
                <li key={etapa} className="flex items-start gap-3">
                  <span className="mt-0.5 flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-[#0A5C8C] text-white">
                    <Check className="h-3.5 w-3.5" />
                  </span>
                  <span className="text-base leading-relaxed text-[#1A1A1A]">{etapa}</span>
                </li>
              ))}
            </ul>
          </Reveal>
          <Reveal delay={0.24}>
            <p className="mt-7 font-mono text-xs uppercase tracking-[0.18em] text-[#0A5C8C]">
              Precisa de um serviço hidráulico ou elétrico? Consulte a HidroPro Serviços Técnicos pelo WhatsApp.
            </p>
          </Reveal>
          <Reveal delay={0.3}>
            <div className="mt-6">
              <WaButton testId="hidropro-team-whatsapp-button" label="Solicitar atendimento pelo WhatsApp" />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
